import * as types from '../constants';

let defaultState = { insurance: null };

export default function reducer(state = defaultState, actions) {
  switch (actions.type) {
  
    case types.SET_INSURANCE:
      return {
        ...state,
        insurance: actions.payload
      }
    default:
      return state
  }
}
